import { MahleAirConditioningBadge } from "@App/Components/atoms/whitelabel/badges/MahleAirConditioningBadge";
import { MahleLogo } from "@App/Components/atoms/whitelabel/logos/MahleLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Mahle whitelabel.
 * Extends the default configuration with specific settings for Mahle.
 */
export const config: Partial<Config> = {
  slug: "mahle",
  internationalNumberPlate: true,
  navbar: {
    logos: {
      left: {
        component: <MahleLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
  },
  // `show` is for the whitelabels on the common home page — Mahle's own renders the sections outright.
  homeSections: {
    image: { src: "/images/partner/mahle/mahle_list_items.png", alt: "MAHLE" },
    benefitItems: [
      "oneStop",
      "partner",
      "originalParts",
      "vehicleData",
      "certifiedAirConditioning",
      "manufacturerSpec",
    ],
  },
  garageListItem: {
    benefitBadge: {
      component: <MahleAirConditioningBadge />,
    },
  },
  reviews: {
    show: true,
  },
  // MAHLE asked not to be listed in the general repareo privacy policy that all other whitelabels link to.
  legal: {
    privacyPolicyUrl:
      "https://app.notion.com/p/Datenschutzerkl-rung-repareo-GmbH-MAHLE-Workshop-Finder-3e4a992ae52f81059bf3f0bf1daac97c",
  },
};

export default config;
